import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PAYMENT_MODAL_CY } from '@/constants/test-id';
import { Z_INDEX } from '@/constants/z-index';
import { useOverlayClickHandler } from '@/hooks/useOverlayClickHandler';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Statuses.styles';

export type EmptyBalanceModalProps = {
  onClose: () => void;
  onAddBalance?: () => void;
};

export const EmptyBalance: FC<EmptyBalanceModalProps> = ({
  onClose,
  onAddBalance
}) => {
  const { t } = useTranslation();

  const handleOverlayClick = useOverlayClickHandler(onClose);

  const isDark = useThemeMode('dark');

  return (
    <S.StatusModalOverlay onClick={handleOverlayClick} $zIndex={Z_INDEX.DIALOG}>
      <S.ModalBox>
        <S.ModalContent>
          <S.ModalTitle>{t('Advertise.attention_label')}</S.ModalTitle>
          <S.ModalSubtitle>
            {t('Advertise.empty_balance_error_label')}
          </S.ModalSubtitle>
        </S.ModalContent>
        <S.ModalActions>
          <S.CloseButton onClick={onClose}>
            {t('Advertise.btn_close')}
          </S.CloseButton>
          <S.AddBalanceButton
            onClick={onAddBalance}
            $isDark={isDark}
            data-cy={PAYMENT_MODAL_CY.TOP_UP_BTN}
          >
            {t('Advertise.btn_top_up_balance')}
          </S.AddBalanceButton>
        </S.ModalActions>
      </S.ModalBox>
    </S.StatusModalOverlay>
  );
};
